// extracted by mini-css-extract-plugin
export default {"input":"add-buyer-modal_input__zXwWw","actions":"add-buyer-modal_actions__Gy0mJ","actionButton":"add-buyer-modal_actionButton__Byb0N"};